import _range from 'lodash/range';

const BUCKET_NAME = 'state.rssi';
const ANY_TEXT = 'Any';

export default class ThingSignalController {
    /** @ngInject */
    constructor(EventEmitter) {
        this.eventEmitter = EventEmitter;
    }

    $onInit() {
        this.anyText = ANY_TEXT;
        this.aboveValue = '';
        this.belowValue = '';
        this.signals = _range(6);
    }

    $onChanges(changes) {
        if (changes.reset) {
            if (!changes.reset.isFirstChange() && changes.reset.currentValue === true) {
                this.resetValues();
            }
        }
    }

    onChange() {
        const thingSignal = this.getThingSignal();

        if (Object.keys(thingSignal).length) {
            this.fillBucket();

            this.pushUpdate(
                this.eventEmitter({
                    value: thingSignal
                })
            );
        } else {
            this.clearBucket();
        }
    }

    getThingSignal() {
        const thingBattery = {};

        if (this.aboveValue !== this.anyText && this.aboveValue.toString().length) {
            thingBattery.above = this.aboveValue;
        }

        if (this.belowValue !== this.anyText && this.belowValue.toString().length) {
            thingBattery.below = this.belowValue;
        }

        return thingBattery;
    }

    fillBucket() {
        this.addItemToBucket(
            this.eventEmitter({
                item: {
                    name: BUCKET_NAME,
                    value: this.getThingSignal()
                }
            })
        );
    }

    clearBucket() {
        this.removeItemFromBucket(
            this.eventEmitter({
                item: {
                    name: BUCKET_NAME
                }
            })
        );
    }

    resetValues() {
        this.aboveValue = '';
        this.belowValue = '';

        this.clearBucket();
    }
}



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/thing-signal/thing-signal.controller.js